<template>
  <!-- Main Sidebar Container -->
  <!--<aside class="main-sidebar sidebar-dark-primary elevation-4">-->
  <!-- Brand Logo -->
  <!--<a
href="#"
class="brand-link">
      <img
src="@/assets/AdminLTELogo.png"
alt="Logo"
class="brand-image img-circle elevation-3"
style="opacity: .8">
      <span class="brand-text font-weight-light"/>
      </a>-->
  <!-- Sidebar -->
  <!--<div class="sidebar">-->
  <!-- Sidebar Menu -->
  <!--<nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false">-->
  <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
  <!--<li class="nav-item has-treeview menu-open">
            <a
              href="#"
              class="nav-link">
              <i class="nav-icon fa fa-circle"/>
              <p>Master
                <i class="right fa fa-angle-left"/>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0001User"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>User</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/PageManagement"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>PageManagement</p>
                </router-link>
              </li>
            </ul>
          </li>-->
  <!-- /.sidebar-menu -->
  <!--</ul></nav></div>-->
  <!-- /.sidebar -->
  <!--</aside>-->
  <div/>
</template>
<script>
export default {
  name: 'Sidebar',
  data: function () {
    return {
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/organisms/OrSidebar.vue